var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.632 9.475l-4.27-7.398a2.153 2.153 0 0 0-3.73 0L1.29 9.602a2.153 2.153 0 0 0 1.864 3.23h8.694a2.153 2.153 0 0 0 1.785-3.357z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.575 9.779L9.65 1.242a2.485 2.485 0 0 0-4.303 0L.333 9.925a2.484 2.484 0 0 0 2.152 3.727H12.515a2.485 2.485 0 0 0 2.06-3.873zm-6.014.83c0 .588-.452 1.037-1.061 1.037s-1.061-.449-1.061-1.036v-.024c0-.585.452-1.037 1.061-1.037s1.061.45 1.061 1.037v.024zm.024-6.988L8.06 8.206c-.035.33-.254.536-.56.536-.306 0-.525-.208-.56-.536L6.415 3.62c-.036-.355.157-.623.487-.623h1.193c.33.003.526.27.49.625z",
  fill: "#E76F67",
  fillRule: "nonzero"
}))));
export default SvgWarning;